import { stringify } from '@/util/urlHelpers';

import { client } from './api';

const rostering = (queryParams = { limit: 1000 }) => {
  return client(`gateway/calendar/rostering?${stringify(queryParams)}`);
};

export { rostering };
